/**
 * Ordered-list helpers for drag-and-drop moves.
 *
 * The server takes a move as "this item, after that one" (see `moveDeliverable`
 * and friends in `lib/api.ts`). A dragged list on screen can also hold drafts
 * the server has never seen, which have no id yet, so the anchor is the nearest
 * SAVED item above the moved one — or null when nothing saved is above it.
 */

/**
 * The anchor for a move: the id of the nearest saved item above `index` in the
 * list as it reads AFTER the local move, or null to move to the top.
 *
 * @param ids - The list's ids after the local move; `undefined` for unsaved drafts
 * @param index - The moved item's position in `ids`
 */
export function anchorAbove(ids: readonly (string | undefined)[], index: number): string | null {
  for (let i = index - 1; i >= 0; i--) {
    const id = ids[i];
    if (id) return id;
  }
  return null;
}
